// Renommé en 'initialTree' pour plus de clarté
export const initialTree = {
  // On spécifie explicitement le point d'entrée
  rootNodeId: '1',
  // Les données de l'arbre sont maintenant dans une propriété 'data'
  data: {
    '1': {
      type: 'question',
      text: 'Votre démarche concerne-t-elle un particulier ou une entreprise ?',
      answers: {
        'Un particulier': '2',
        'Une entreprise': '100',
      },
    },
    '2': {
      type: 'question',
      text: "Concerne-t-elle un voyage à l'international ?",
      answers: {
        'Oui': '3',
        'Non': '10',
      },
    },
    // ... (le reste de vos données reste identique)
    '3': {
      type: 'question',
      text: 'Êtes-vous citoyen(ne) de ce pays ?',
      answers: {
        'Oui': '4',
        'Non': '5',
      },
    },
    '4': {
      type: 'result',
      name: 'Demande de Passeport',
      description: "Ceci est la procédure pour les citoyens souhaitant obtenir un passeport pour voyager à l'étranger.",
      link: 'https://www.service-public.fr/particuliers/vosdroits/F1163',
    },
    '5': {
      type: 'result',
      name: 'Demande de Visa',
      description: "Ceci est la procédure pour les non-citoyens qui souhaitent entrer dans le pays.",
      link: 'https://france-visas.gouv.fr/',
    },
    '10': {
      type: 'question',
      text: "Est-ce lié à la conduite d'un véhicule ?",
      answers: {
        'Oui': '11',
        'Non': '20',
      },
    },
    '11': {
      type: 'result',
      name: 'Renouvellement du Permis de Conduire',
      description: "Ceci est la procédure pour renouveler un permis de conduire existant.",
      link: 'https://www.service-public.fr/particuliers/vosdroits/F19895',
    },
    '20': {
      type: 'result',
      name: "Demande d'Acte de Naissance",
      description: "Ceci est la procédure pour obtenir une copie officielle d'un acte de naissance.",
      link: 'https://www.service-public.fr/particuliers/vosdroits/F1427',
    },
    '100': {
      type: 'question',
      text: "Êtes-vous en train de créer l'entreprise ?",
      answers: {
        'Oui': '101',
        'Non': '110',
      },
    },
    '101': {
      type: 'result',
      name: "Immatriculation d'Entreprise",
      description: "Ceci est la première étape pour enregistrer officiellement une nouvelle entité commerciale.",
      link: 'https://www.service-public.fr/professionnels-entreprises/vosdroits/F32176',
    },
    '110': {
      type: 'result',
      name: 'Déclaration Annuelle de Revenus pour Petites Entreprises',
      description: "Ceci est la procédure pour les entreprises existantes pour déclarer leurs impôts annuels.",
      link: 'https://www.impots.gouv.fr/professionnel/declarer-resultat',
    },
  },
};
